import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BezpieczenstwoPage from "../pages/bezpieczenstwo/page";
import PorownaniePage from "../pages/porownanie/page";
import PoradnikPage from "../pages/poradnik/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/bezpieczenstwo",
    element: <BezpieczenstwoPage />,
  },
  {
    path: "/porownanie",
    element: <PorownaniePage />,
  },
  {
    path: "/poradnik",
    element: <PoradnikPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;